import React from "react";

function ConfirmModal({ message, onConfirm, onCancel }) {
  const isDark = document.body.classList.contains("dark-mode");

  const modalBg = isDark ? "#222" : "white";
  const buttonCancelBg = isDark ? "#555" : "#3e3f3fff";

  return (
    <div style={modalOverlayStyle}>
      <div style={{ ...modalStyle, backgroundColor: modalBg, color: isDark ? "#fff" : "#000" }}>
        <h3>{message}</h3>
        <div style={{ marginTop: "15px" }}>
          <button onClick={onConfirm} style={{ ...buttonStyle, backgroundColor: "#e4190bff" }}>
            Yes
          </button>
          <button
            onClick={onCancel}
            style={{ ...buttonStyle, backgroundColor: buttonCancelBg, marginLeft: "10px" }}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}


// Styles
const modalOverlayStyle = { position: "fixed", top:0, left:0, width:"100%", height:"100%", backgroundColor:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000 };
const modalStyle = { backgroundColor:"white", padding:"20px", borderRadius:"10px", textAlign:"center", maxWidth:"500px" };
const buttonStyle = { padding:"8px 15px", border:"none", borderRadius:"5px", color:"white", cursor:"pointer" };

export default ConfirmModal;
